import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';

export enum GridStateKey {
  DocumentGenerationTemplateGrid = 'DOCUMENT_GENERATION_TEMPLATE_GRID_STATE',
  EstateTaskTemplatesGrid = 'ESTATE_TASK_TEMPLATES_GRID_STATE',
  RequiredInformationFormatGrid = 'REQUIRED_INFORMATION_FORMAT_GRID_STATE',
  TaskListGrid = 'TASK_LIST_GRID_STATE',
  AllClientsGrid = 'ALL_CLIENTS_GRID_STATE',
  ConditionalTemplateQuestionGrid = 'CONDITIONAL_TEMPLATE_QUESTION_GRID_STATE',
  ConditionalTemplateFilterGrid = 'CONDITIONAL_TEMPLATE_FILTER_GRID_STATE',
  ConditionalTemplateAnswersGrid = 'CONDITIONAL_TEMPLATE_ANSWERS_GRID_STATE',
  ConditionalTemplateQuestionSetGrid = 'CONDITIONAL_TEMPLATE_QUESTION_SET_GRID_STATE',
  MasterTaskListGrid = 'MASTER_TASK_LIST_GRID_STATE',
  AssignedTasksDataGrid = 'ASSIGNED_TASKS_DATA_GRID_STATE',
  EstateList = 'ESTATE_LIST_GRID_STATE',
  ArchivedEstateList = 'ARCHIVED_ESTATE_LIST_GRID_STATE',
}

export const clearAllGridStates = () => {
  Object.values(GridStateKey).forEach((key) => {
    localStorage.removeItem(key);
  });
};

export const clearGridState = (gridStateKey: GridStateKey) => {
  localStorage.removeItem(gridStateKey);
};

export const restoreGridState = (
  gridApiCurrentRef: GridApiPremium,
  gridStateKey: GridStateKey,
  portalId?: string,
) => {
  if (gridApiCurrentRef && gridApiCurrentRef.restoreState) {
    // Restore grid to previously saved state
    try {
      let state = localStorage.getItem(gridStateKey);
      if (portalId) {
        state = localStorage.getItem(`${gridStateKey}-${portalId}`);
      }
      if (state) {
        gridApiCurrentRef.restoreState(JSON.parse(state));
        gridApiCurrentRef.hideFilterPanel(); // hide filter panel because calling restoreState always opens it for whatever reason
      }
    } catch (e) {
      console.log(e);
    }
  }
};

export const refreshGridState = (gridStateKey: GridStateKey) => {
  const event = new CustomEvent('refreshGridState', { detail: { gridStateKey } });
  window.dispatchEvent(event);
};

export const saveGridState = (
  gridApiCurrentRef: GridApiPremium,
  gridStateKey: GridStateKey,
  portalId?: string,
) => {
  if (gridApiCurrentRef && gridApiCurrentRef.exportState) {
    const state = gridApiCurrentRef.exportState();
    if (portalId) {
      localStorage.setItem(`${gridStateKey}-${portalId}`, JSON.stringify(state));
      return;
    }
    localStorage.setItem(gridStateKey, JSON.stringify(state));
  }
};
